import { list, object, serializable } from 'serializr';

export class DashboardService {
  @serializable
  id!: number;

  @serializable
  name!: string;
}

export class DashboardServicesResponse {
  @serializable(list(object(DashboardService)))
  services!: DashboardService[];
}

export class InfrastructureSettings {
  @serializable
  workOrderSummary!: boolean;

  @serializable
  workOrderCalendar!: boolean;
}

// Deprecated; the PUT schema still requires the key.
export class MarsSettings {
  @serializable
  claimSummary!: boolean;
}

export class DashboardSettings {
  @serializable(object(InfrastructureSettings))
  infrastructure!: InfrastructureSettings;

  @serializable(object(MarsSettings))
  mars!: MarsSettings;
}
